import React from "react";
import "./styles.scss";
// import { FiMenu } from "react-icons/fi";

interface IProps {
  title: String;
}

const PageTitle = (props: IProps) => {
  return (
    <div className="page-title-wrapper font-weight-bold">
      {/* <span>
        <FiMenu />
      </span> */}
      {props.title}
    </div>
  );
};

export default PageTitle;
